import { Navigate, type RouteObject } from 'react-router';
import { PortalLayout } from './PortalLayout';
import { PortalAccountPage } from './pages/PortalAccountPage';
import { PortalHomePage } from './pages/PortalHomePage';
import { PortalRequestPage } from './pages/PortalRequestPage';

// Portal klienta (DECISIONS 2026-10-17 [P] „Model portalu klienta”): osobny układ i trasy pod /portal.
// Strażnik roli (osoba klienta widzi tylko portal, zespół nie widzi portalu): app/guards.tsx.
export { type ConversationItem, ConversationList, MessageComposer } from './components/Conversation';
export { PortalStatusPill } from './components/PortalStatus';
export { PortalLayout };

/** Trasy portalu (dzieci `/portal`); nieznana ścieżka wraca na listę zgłoszeń. */
export const portalRoutes: RouteObject[] = [
  { index: true, element: <PortalHomePage /> },
  { path: 'zgloszenia/:id', element: <PortalRequestPage /> },
  { path: 'konto', element: <PortalAccountPage /> },
  { path: '*', element: <Navigate to="/portal" replace /> },
];
